<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="培训报名" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="danger" v-if="editData.djzt === '提交'" @click="unSubmit">撤销</a-button>
                <a-button :loading="saving || loading" @click="onPrint">打印</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                            <FGCollapsiblePanel title="培训报名">
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="报名表编号">
                                            <a-input ref="bmsqbbh" v-model="editData.bmsqbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="报名日期">
                                            <a-date-picker ref="bmrq" v-model="editData.bmrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="报名单位编号">
                                            <a-input ref="bmdwbh" v-model="editData.bmdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="报名单位名称">
                                            <FGDictSelectCN ref="bmdwmc" dictNo="RY100101" v-model="editData.bmdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="班级名称">
                                            <a-input ref="bjmc" v-model="editData.bjmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="班级类别">
                                            <a-input ref="bjlb" v-model="editData.bjlb" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="班级人数">
                                            <a-input ref="bjrs" v-model="editData.bjrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="报名人数">
                                            <a-input ref="bmrs" v-model="editData.bmrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="报名开始日期">
                                            <a-input ref="ksrq" v-model="editData.ksrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="报名结束日期">
                                            <a-input ref="jsrq" v-model="editData.jsrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="培训开始日期">
                                            <a-input ref="pxksrq" v-model="editData.pxksrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="培训结束日期">
                                            <a-input ref="pxjsrq" v-model="editData.pxjsrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="培训内容">
                                            <a-input ref="pxnr" v-model="editData.pxnr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="培训地点">
                                            <a-input ref="pxdd" v-model="editData.pxdd" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="联系人">
                                            <a-input ref="lxr" v-model="editData.lxr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系电话">
                                            <a-input ref="lxdh" v-model="editData.lxdh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="纳税人识别号">
                                            <a-input ref="nsrsbh" v-model="editData.nsrsbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="开票地址">
                                            <a-input ref="kpdz" v-model="editData.kpdz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="开票电话">
                                            <a-input ref="kpdh" v-model="editData.kpdh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="开户行">
                                            <a-input ref="khh" v-model="editData.khh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="开户行账号">
                                            <a-input ref="khzh" v-model="editData.khzh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="备注">
                                            <a-input ref="bz" v-model="editData.bz" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="报名申请表明细">
                                <!-- 表格 -->
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools> </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="itemTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemData"
                                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.xh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="xm" title="姓名" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input-search ref="xm" readOnly @search="searchByXM(scope.row)" v-model="scope.row.xm" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="xb" title="性别" align="center" width="90px">
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="scope.row.xb" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zjhm" title="证件号码" width="150" sortable align="center"></vxe-table-column>
                                    <vxe-table-column field="rylb" title="人员类别" align="center">
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="rylb" dictNo="RY100104" v-model="scope.row.rylb" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="ssdwmc" title="所属单位名称" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.ssdwmc" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zcdwmc" title="登记单位名称" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zcdwmc" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="lxdh" title="联系电话" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.lxdh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="xxdz" title="详细地址" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.xxdz" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="yzbm" title="邮政编码" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.yzbm" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="sfzs" title="是否住宿" align="center">
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="sfzs" dictNo="1101" v-model="scope.row.sfzs" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zsyq" title="住宿要求" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zsyq" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="jhrdsj" title="计划入店时间" align="center">
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="jhrdsj" v-model="scope.row.jhrdsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="jhldsj" title="计划离店时间" align="center">
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="jhldsj" v-model="scope.row.jhldsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zczt" title="登记状态" align="center">
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="zczt" dictNo="RY100108" v-model="scope.row.zczt" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bz" />
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 流程跟踪组件 -->
                        <OperLog ref="activitishow" :operLogProps="operLogProps"></OperLog>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
export default {
    name: "PxbmForm",
    props: ["showForm", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 培训记录明细数据
            editItemData: [],
            editItemDataLoading: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading || this.editItemDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                fktable: "RY_BMSQB",
                fkfield: "ID",
                attachsource: "RY5000",
                fkvalue: this.editData.id
            };
        }
    },
    activated() {
        // 修改，加载数据
        this.loadData();
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/pxbm/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                    this.loadItemData();
                    this.initOperLog();
                });
        },
        // 加载明细表数据
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/pxbm/listItem",
                    {
                        id: this.editDataId,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        unSubmit() {
            this.$FG_http
                .post("./api/main/jsry/pxbm/unSubmit", {
                    id: this.editData.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    } else {
                        this.$refs.bmsqbbh.focus();
                    }
                });
        },
        //打印
        onPrint() {
            this.$FG_http
                .post(
                    "./api/main/report/generateReport",
                    {
                        ID: this.editData.id,
                        rptid: "BMSQBMX"
                    },
                    {
                        responseType: "blob",
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let binaryData = [];
                        binaryData.push(data);
                        let url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
                        window.open(url);
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
